import type { TaskApprovalGuards } from '../../../../api/types';

const defaultTaskApprovalGuards: TaskApprovalGuards = {
  preExecution: false,
  postExecution: false,
};

export function normalizeTaskApprovalGuards(
  value: unknown
): TaskApprovalGuards {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return { ...defaultTaskApprovalGuards };
  }

  const raw = value as Partial<Record<keyof TaskApprovalGuards, unknown>>;
  return {
    preExecution: raw.preExecution === true,
    postExecution: raw.postExecution === true,
  };
}
